import { useState, useEffect } from "react";
import { AdminField, AdminSaveButton, AdminSection } from "@/admin/AdminComponents";

const FooterEditor = ({ data, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => { setForm({ ...data }); }, [data]);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));

  return (
    <div data-testid="footer-editor">
      <AdminSection title="Footer" description="Footer content settings">
        <AdminField label="Company Name" value={form.company_name} onChange={(v) => update("company_name", v)} />
        <AdminField label="Email" value={form.email} onChange={(v) => update("email", v)} type="email" />
      </AdminSection>

      <AdminSaveButton onClick={() => onSave(form)} saving={saving} />
    </div>
  );
};

export default FooterEditor;
